import React from "react";
import i18n from "../../constants/i18n";
import { DASHBOARD_HEADERS } from "../../constants/table-custom-headers/Alarms";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Table from "../../core/et3-table";
import getDashBoardStore from "../../stores/dashboard-store";
import Et3Margin from "../../core/et3-ui/ET3Margin";

const AlarmDetails = withLiteObserverAndTheme(() => {
  const { alertLogs } = getDashBoardStore().alertsData.get();

  return (
    <React.Fragment>
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("NEW_USERS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.NEW_USER_LOG_ISSUE}
        shouldBeFlagged={false}
        titleKey={"NEW_USERS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("FB_USERS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.FB_USER_LOG_ISSUE}
        shouldBeFlagged={false}
        titleKey={"FB_USERS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("SMS_USERS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.SMS_USER_LOG_ISSUE}
        shouldBeFlagged={false}
        titleKey={"SMS_USERS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("EMAIL_USERS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.EMAIL_USER_LOG_ISSUE}
        shouldBeFlagged={false}
        titleKey={"EMAIL_USERS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("EMAIL_SENT")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.EMAIL_SENT}
        shouldBeFlagged={false}
        titleKey={"EMAIL_SENT_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get(
          "UNSUBSCRIBED_USER_ACTIVITY_EMAILS"
        )} - ${i18n.get("ALERT")}`}
        rows={alertLogs.UNSUBSCRIBED_USER_ACTIVITY_EMAILS}
        shouldBeFlagged={false}
        titleKey={"UNSUBSCRIBED_USER_ACTIVITY_EMAILS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get(
          "UNSUBSCRIBED_PROMOTIONAL_EMAILS"
        )} - ${i18n.get("ALERT")}`}
        rows={alertLogs.UNSUBSCRIBED_PROMOTIONAL_EMAILS}
        shouldBeFlagged={false}
        titleKey={"UNSUBSCRIBED_PROMOTIONAL_EMAILS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get(
          "UNSUBSCRIBED_NEW_MESSAGE_EMAILS"
        )} - ${i18n.get("ALERT")}`}
        rows={alertLogs.UNSUBSCRIBED_NEW_MESSAGE_EMAILS}
        shouldBeFlagged={false}
        titleKey={"UNSUBSCRIBED_NEW_MESSAGES_EMAILS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get(
          "UNSUBSCRIBED_VISIT_PROFILE_EMAILS"
        )} - ${i18n.get("ALERT")}`}
        rows={alertLogs.UNSUBSCRIBED_VISIT_PROFILE_EMAILS}
        shouldBeFlagged={false}
        titleKey={"UNSUBSCRIBED_VISIT_PROFILE_EMAILS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("UNSUBSCRIBED_LIKE_EMAILS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.UNSUBSCRIBED_LIKE_EMAILS}
        shouldBeFlagged={false}
        titleKey={"UNSUBSCRIBED_LIKE_EMAILS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("LAST_LOGIN_USERS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.LAST_LOGIN_LOG_ISSUE}
        shouldBeFlagged={false}
        titleKey={"LAST_LOGIN_USERS"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("ANDROID_PAYMENTS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.ANDROID_PAYMENTS}
        shouldBeFlagged={false}
        titleKey={"ANDROID_PAYMENTS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("IOS_PAYMENTS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.IOS_PAYMENTS}
        shouldBeFlagged={false}
        titleKey={"IOS_PAYMENTS_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("RATE_LIMIT")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.RATE_LIMIT}
        shouldBeFlagged={false}
        titleKey={"RATE_LIMIT_ALERT_MODE"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={DASHBOARD_HEADERS}
        title={`${i18n.get("FLAGGED_CONNECTIONS")} - ${i18n.get("ALERT")}`}
        rows={alertLogs.FLAGGED_CONNECTIONS}
        shouldBeFlagged={false}
        titleKey={"FLAGGED_CONNECTIONS_ALERT_MODE"}
      />
    </React.Fragment>
  );
});

export default AlarmDetails;
